'use client';

import { useState } from 'react';
import StarIcon from '@/components/ui/icons/star-icon';
import { formatKSA } from '@/utils/global';

const ProductReviews = ({ reviews, t }) => {
  const [showAll, setShowAll] = useState(false);

  const sortedReviews = [...reviews]?.sort(
    (a, b) => new Date(b?.created_at) - new Date(a?.created_at)
  );

  // Only show 4 reviews unless showAll = true
  const displayedReviews = showAll ? sortedReviews : sortedReviews?.slice(0, 4);

  if (reviews?.length === 0) {
    return (
      <p className='font-bold text-gray-600 max-sm:text-sm'>
        {t('no_reviews')}
      </p>
    );
  }

  return (
    <div className='max-w-3xl space-y-4'>
      <div className='grid grid-cols-1 gap-4 md:grid-cols-2'>
        {displayedReviews?.map((review) => {
          // Safely extract rating (defaults to 0 if missing)
          const ratingValue = review?.ratings?.[0]?.value ?? 0;

          return (
            <div
              key={review?.id}
              className='rounded-lg border border-gray-200 p-4 transition-shadow hover:shadow-md'
            >
              <div className='flex justify-between'>
                <span className='font-medium'>{review?.nickname}</span>
                <div className='flex'>
                  {[1, 2, 3, 4, 5].map((star) => (
                    <StarIcon
                      key={star}
                      size={14}
                      className={
                        star <= ratingValue
                          ? 'fill-yellow-400 text-yellow-400'
                          : 'fill-gray-200 text-gray-200'
                      }
                    />
                  ))}
                </div>
              </div>
              <div className='mt-1 text-xs text-gray-500'>
                {formatKSA(review?.created_at)}
              </div>
              <p className='mt-2 text-sm'>{review?.detail}</p>
            </div>
          );
        })}
      </div>

      {/* Toggle button */}
      {reviews?.length > 4 && (
        <button
          onClick={() => setShowAll(!showAll)}
          className='border-primary text-primary mt-2 w-full rounded-lg border py-2.5 text-sm font-medium transition-colors hover:bg-[#f8f9ff]'
        >
          {showAll
            ? t('Hide Reviews')
            : `${t('View All Reviews')} (${reviews?.length})`}
        </button>
      )}
    </div>
  );
};

export default ProductReviews;
